export default class ProfilePermissionsService {
  constructor($window) {
    this.$localStorage = $window.localStorage;
  }

  setProfilesCount(count) { this.$localStorage.setItem('profilesCount', count); }
  hasProfiles() { return +this.$localStorage.getItem('profilesCount') > 0; }

  setProfile(profile) {
    this.$localStorage.setItem('currentProfile', JSON.stringify(profile));
  }

  getProfile() {
    return JSON.parse(this.$localStorage.getItem('currentProfile'));
  }

  clearProfile() {
    this.$localStorage.removeItem('currentProfile');
  }

  isAdmin() {
    return this.getProfile().is_admin;
  }

  hasPermission(perm) {
    return this.isAdmin() ? true : this.getProfile().permissions.indexOf(perm) > -1;
  }

  hasAtLeastOneOf(permList) {
    return this.isAdmin() || this.getProfile().permissions.some(perm => permList.indexOf(perm) > -1);
  }

  hasAllOf(permList) {
    var profile = this.getProfile();
    return this.isAdmin() || permList.every(perm => profile.permissions.indexOf(perm) > -1);
  }
}

ProfilePermissionsService.$inject = ['$window'];


// WEBPACK FOOTER //
// ./src/app/services/profile-permissions.service.js